import { ApiResponse, CalculateCustomizedSolutionProductResponse } from "../Models";

// With product
export const calculateCustomizedSolutionProductMockup: ApiResponse<CalculateCustomizedSolutionProductResponse> = {
  statusCode: 200,
  error: null,
  data: {
    currentDayReleaseRemainValues: [],
    bestSuitFormula: "Multicote Agri 4M 25-04-24",
    bestSuitFormulaCoatings: "(10-20-30%)",
    formulaNutrients: {
      n: 125,
      p: 4,
      k: 24,
    },
    applicationVolume: [
      { value: 1120, mesurmentUnitCode: "1", mesurmentUnit: "ST/Acre" },
      { value: 500, mesurmentUnitCode: "2", mesurmentUnit: "ST/Acre" },
    ],
    cropDemand: [
      { mesurmentUnitCode: "1", mesurmentUnit: "ST/Acre", cropDemand: { n: 50, p: 50, k: 50 } },
      { mesurmentUnitCode: "2", mesurmentUnit: "yul", cropDemand: { n: 50, p: 50, k: 50 } },
    ],
    recipe: {
      coated: [
        { id: 14, name: "Multicote 2M 11-49-00", precentage: 17 },
        { id: 2, name: "MultiCote Agri 25-5-11", precentage: 11 },
        { id: 3, name: "MultiCote Agri 25-4-11", precentage: 0 },
      ],
      unCoated: [
        { id: 4, name: "Amonnium Sulphate", precentage: 37 },
        { id: 5, name: "Potasium Sulphate", precentage: 29 },
        { id: 6, name: "MAP", precentage: 6 },
      ],
    },
    releaseGraphValues: [
      {
        index: 0,
        month: 1,
        nutrient: [
          {
            name: "N",
            releaseValues: [
              { value: 50, mesurmentUnitCode: "1", mesurmentUnit: "Kg/Ha" },
              { value: 53, mesurmentUnitCode: "2", mesurmentUnit: "ST/Acre" },
            ],
          },
          {
            name: "P",
            releaseValues: [
              { value: 50, mesurmentUnitCode: "1", mesurmentUnit: "Kg/Ha" },
              { value: 53, mesurmentUnitCode: "2", mesurmentUnit: "ST/Acre" },
            ],
          },
          {
            name: "K",
            releaseValues: [
              { value: 50, mesurmentUnitCode: "1", mesurmentUnit: "Kg/Ha" },
              { value: 53, mesurmentUnitCode: "2", mesurmentUnit: "ST/Acre" },
            ],
          },
        ],
      },
    ],
  },
};

// Without product
// export const calculateCustomizedSolutionProductMockup: ApiResponse<CalculateCustomizedSolutionProductResponse> =
//   {
//   statusCode: 200,
//   error: null,
//   data: {
//     mostRecommendedFormula: null,
//     materialCode: null,
//     applicationVolume: [
//       {value: 1120, mesurmentUnitCode: '1', mesurmentUnit: 'ST/Acre'},
//       {value: 500, mesurmentUnitCode: '2', mesurmentUnit: 'ST/Acre'},
//     ],
//     cropDemand: {N: 50, P: 50, K: 50},
//     recipe: {
//       coated: [
//         {name: 'Multicote 2M 11-49-00 (70-30-50%)', precentage: '17'},
//         {name: 'MultiCote Agri 25-5-11 (70-30-50%)', precentage: '11'},
//         {name: 'MultiCote Agri 25-5-11 (70-30-50%)', precentage: '0'},
//       ],
//       uncoated: [
//         {name: 'Amonnium Sulphate', precentage: '37'},
//         {name: 'Potasium Sulphate', precentage: '29'},
//         {name: 'MAP', precentage: '6'},
//       ],
//     },
//     releaseGraphValues: [
//       {
//         nutrient: 'N',
//         month: 1,
//         releaseValues: [
//           {value: 50, mesurmentUnitCode: '1', mesurmentUnit: 'Kg/Ha'},
//           {value: 53, mesurmentUnitCode: '2', mesurmentUnit: 'ST/Acre'},
//         ],
//       },
//       {
//         nutrient: 'P',
//         month: 1,
//         releaseValues: [
//           {value: 1000, mesurmentUnitCode: '1', mesurmentUnit: 'Kg/Ha'},
//           {value: 500, mesurmentUnitCode: '2', mesurmentUnit: 'ST/Acre'},
//         ],
//       },
//       {
//         nutrient: 'K',
//         month: 1,
//         releaseValues: [
//           {value: 66, mesurmentUnitCode: '1', mesurmentUnit: 'Kg/Ha'},
//           {value: 800, mesurmentUnitCode: '2', mesurmentUnit: 'ST/Acre'},
//         ],
//       },
//       {
//         nutrient: 'N21',
//         month: 1,
//         releaseValues: [
//           {value: 66, mesurmentUnitCode: '1', mesurmentUnit: 'Kg/Ha'},
//           {value: 888, mesurmentUnitCode: '2', mesurmentUnit: 'ST/Acre'},
//         ],
//       },
//       {
//         nutrient: 'P21',
//         month: 1,
//         releaseValues: [
//           {value: 12, mesurmentUnitCode: '1', mesurmentUnit: 'Kg/Ha'},
//           {value: 32, mesurmentUnitCode: '2', mesurmentUnit: 'ST/Acre'},
//         ],
//       },
//       {
//         nutrient: 'K21',
//         month: 1,
//         releaseValues: [
//           {value: 88, mesurmentUnitCode: '1', mesurmentUnit: 'Kg/Ha'},
//           {value: 12, mesurmentUnitCode: '2', mesurmentUnit: 'ST/Acre'},
//         ],
//       },
//     ],
//   },
// };
